import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import Dashboard from './app/dashboard'

class App extends Component {

  render() {
    return (<Dashboard/>)
  }
}
export default (App);
